import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText, { fragment } from '../../../../Core/RichText';
import Link from '../../../../Core/Link';
import CtaModal from '../../../CtaModal';

import {
  Segment,
  SegmentHeader,
  Feature,
  StyledSpan,
  StyledImage,
} from './styles';

const ProductIconText = ({ data, className = '' }) => {
  if (!data) return null;

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <SegmentHeader>{children}</SegmentHeader>
      ),
    },
  };

  const textOptions = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => {
        return <StyledSpan>{children}</StyledSpan>;
      },
    },
  };

  const { header, listOfFeatures } = data;

  return (
    <Segment className={className}>
      {header && <RichText document={header} options={options} />}
      {listOfFeatures && (
        <ul>
          {listOfFeatures.map(feature => {
            if (feature?.internal?.type === 'ContentfulCta') {
              return (
                <Link key={feature.id} data={feature}>
                  <RichText document={feature.label} options={fragment} />
                </Link>
              );
            }
            if (feature?.internal?.type === 'ContentfulModal') {
              return <CtaModal key={feature.id} data={feature} />;
            }
            return (
              <Feature key={feature.id} className="icon-with-text">
                {feature.iconDam && (
                  <StyledImage
                    src={feature.iconDam}
                    altText={feature.iconDam.altText || ''}
                  />
                )}
                {feature.text && (
                  <RichText document={feature.text} options={textOptions} />
                )}
              </Feature>
            );
          })}
        </ul>
      )}
    </Segment>
  );
};

ProductIconText.propTypes = {
  data: PropTypes.shape().isRequired,
  className: PropTypes.string,
};

export default ProductIconText;
